import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { action, observable, runInAction, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';

import { HotKeys } from 'react-hotkeys';
import { ITipoMinuta, Minuta, Processo } from '../modelo';
import { b64DecodeUnicode } from '../utils/Base64Utils';
import { VersaoMinutaDto } from '../modelo/dto/VersaoMinutaDto';
import MinutaService from '../services/MinutaService';
import { TextSnippet } from '@mui/icons-material';


interface IPropsVisualizarVersaoMinuta {
    versao?: VersaoMinutaDto;
    processo: Partial<Processo>;
    minuta: Minuta;
}


class VisualizarVersaoMinuta extends React.Component<IPropsVisualizarVersaoMinuta> {
    minutaHTML: string = '';
    modalAberto: boolean = false;

    abrirMinuta = async () => {        
        let minuta = await MinutaService.visualizarVersaoMinuta(this.props.versao);
        runInAction(() => {
            minuta = b64DecodeUnicode((minuta as any).conteudoOriginal || 'Não foi possivel recuperar a minuta');

            // arrumando posição do timbre
            this.minutaHTML = (minuta as string).replace('style="position: absolute;left: 0;top: -0.14in;padding-top: 12mm;padding-left: 26mm;width: 0.7362205in;height: 0.7637795in"', 'style="position: absolute;left: 0;top: -0.14in;margin-top: 12mm;margin-left: 26mm;width: 0.7362205in;height: 0.7637795in"');
            this.modalAberto = true;
        });
    }

    closeModal = () => {
        this.modalAberto = false;
    };

    constructor(props: IPropsVisualizarVersaoMinuta) {
        super(props);

        makeObservable(this, {
            minutaHTML: observable,
            modalAberto: observable,
            closeModal: action
        });
    }

    render() {
        const tooltipTitle = `Visualizar o conteúdo da versão minuta de ${this.props.minuta?.tipo?.descricao?.toLowerCase()}`;
        return (
            <>
                <Tooltip title={tooltipTitle}>
                    <div>
                        <IconButton size='small' onClick={this.abrirMinuta} id={'visualizar-minuta-' + this.props.processo.identificadorProcesso + '-' + this.props.minuta.tipo.codigo}
                            aria-label={tooltipTitle}>
                            <TextSnippet />
                        </IconButton>
                    </div>
                </Tooltip>
                <Dialog open={this.modalAberto} maxWidth='md' onClose={this.closeModal} >
                    <DialogTitle>
                        Visualizando {this.props.minuta?.tipo?.descricao} do processo {this.props.processo.numeroProcesso}
                    </DialogTitle>
                    <DialogContent>
                        <div dangerouslySetInnerHTML={{ __html: this.minutaHTML }}>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' color='primary' onClick={this.closeModal}>
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default observer(VisualizarVersaoMinuta);
